import { Loading } from "@evertrue/et-components";
import { PropTypes } from "base/react-libs";
import useRecommendedActions from "../hooks/use-recommended-actions";
import RecommendedActionSection from "./recommended-action-section";

const GiftAnniversaryRecommendedActions = ({ enabled }) => {
  const { loading, recommendedActions } = useRecommendedActions("giftAnniversary", enabled);

  if (!enabled) return null;
  if (loading) return <Loading />;
  return (
    <RecommendedActionSection
      title="Upcoming gift anniversary in the next 30 days"
      subtitle="Last Gift"
      recommendedActions={recommendedActions}
      icon={"anniversary"}
      type="gift"
    />
  );
};

GiftAnniversaryRecommendedActions.propTypes = {
  enabled: PropTypes.bool,
};

export default GiftAnniversaryRecommendedActions;
